import { render, staticRenderFns } from "./VoucherByOrganizations.vue?vue&type=template&id=1ca30ca7&"
import script from "./VoucherByOrganizations.vue?vue&type=script&lang=js&"
export * from "./VoucherByOrganizations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports